import type { ComponentType, SVGProps } from 'react';
import { SparklesIcon, BeakerIcon } from '@heroicons/react/24/outline';

export interface Product {
  name: string;
  url: string;
  domain: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  tagline: string;
  description: string;
  highlights: string[];
}

export const products: Product[] = [
  {
    name: 'Prompt Shots',
    url: 'https://prompt-shots.com',
    domain: 'prompt-shots.com',
    icon: SparklesIcon,
    tagline: 'All your prompts, in your pocket',
    description:
      'A prompt library and workspace that syncs across mobile and web. Capture prompts with your camera, organize them, chain them into workflows, and send them to any AI tool with one tap.',
    highlights: [
      'Scan prompts from any screen, image, or print',
      'Organize into Playfields and Packs, chain multi-step workflows',
      'One tap to ChatGPT, Claude, Gemini, or Copilot',
    ],
  },
  {
    name: 'AI Gut Check',
    url: 'https://aigutcheck.com',
    domain: 'aigutcheck.com',
    icon: BeakerIcon,
    tagline: 'What should AI do? Ask the people.',
    description:
      'Public views on real AI incidents. What an agent did, and what people think it should have done. The data is turned into technical artifacts you can use to build more aware AI systems.',
    highlights: [
      'Open dataset of real responses, released CC0',
      'Plain-text ruleset you can paste into a system prompt',
      'Evals, disagreement map and a Gut Check Score for any model',
    ],
  },
];
